<!--
    Ein Frage-Antwort-Paar. Die Frage ist ein echter <button>, damit Tastatur,
    Fokus und Screenreader-Ausgabe vom Browser kommen; aria-expanded und
    aria-controls verbinden ihn mit der Antwort.

    Ohne Container arbeitet das Panel mit eigenem Zustand weiter.
-->
<script setup>
import { computed, inject, ref, useId } from "vue";

const props = defineProps({
    // Startzustand aus dem Markup — die Pflege legt fest, welche Frage offen ist.
    open: Boolean,
});

const accordion = inject("accordion", null);

const panelId = useId();
const contentId = `${panelId}-answer`;
const standaloneOpen = ref(props.open);

const isOpen = computed(() =>
    accordion ? accordion.isOpen(panelId) : standaloneOpen.value
);

const toggle = () => {
    if (accordion) {
        accordion.toggle(panelId);
    } else {
        standaloneOpen.value = !standaloneOpen.value;
    }
};

// Der offene Startzustand muss beim Container ankommen, der führt die Liste.
if (accordion && props.open) {
    accordion.setOpen(panelId, true);
}
</script>

<template>
    <div class="accordion-panel" :class="{ 'accordion-panel--open': isOpen }">
        <button
            type="button"
            class="accordion-panel__question"
            :aria-expanded="isOpen ? 'true' : 'false'"
            :aria-controls="contentId"
            @click="toggle"
        >
            <slot name="headline" />
            <span class="accordion-panel__marker" aria-hidden="true"></span>
        </button>

        <expand-transition>
            <div v-show="isOpen" :id="contentId" class="accordion-panel__answer">
                <!-- Das Padding sitzt innen: die Höhe des äusseren Elements wird
                     animiert, und ein Padding dort liesse sich nicht auf 0
                     zusammenfahren. -->
                <div class="accordion-panel__answer-inner">
                    <slot />
                </div>
            </div>
        </expand-transition>
    </div>
</template>
